import { useState } from "react";
import { Flame } from "lucide-react";

export default function AdminPage() {
  const [key,         setKey]         = useState("");
  const [data,        setData]        = useState(null);
  const [loading,     setLoading]     = useState(false);
  const [err,         setErr]         = useState("");
  const [clearStatus, setClearStatus] = useState("");

  const clearTrackRecord = async () => {
    if (!key) return;
    setClearStatus("clearing…");
    try {
      const r = await fetch(`/api/track?key=${encodeURIComponent(key)}`, { method: "DELETE" });
      if (r.status === 401) { setClearStatus("Wrong key."); return; }
      const d = await r.json();
      setClearStatus(d.message || "Cleared.");
    } catch { setClearStatus("Network error."); }
  };

  const load = async () => {
    setLoading(true); setErr(""); setData(null);
    try {
      const r = await fetch(`/api/admin?key=${encodeURIComponent(key)}`);
      if (r.status === 401) { setErr("Wrong key."); setLoading(false); return; }
      const d = await r.json();
      setData(d);
    } catch { setErr("Network error."); }
    setLoading(false);
  };

  const RANK_COLORS = ["#FF6B35","#e8c875","#00C805","#60A5FA","#9B9B9B"];

  return (
    <div style={{ fontFamily:"'Inter',sans-serif", background:"#000", minHeight:"100vh", color:"#fff", padding:"40px 24px" }}>
      <style>{"*{box-sizing:border-box}"}</style>
      <div style={{ maxWidth:900, margin:"0 auto" }}>
        <div style={{ marginBottom:32 }}>
          <div style={{ fontSize:11, fontWeight:900, letterSpacing:".2em", textTransform:"uppercase", color:"#e8c875", marginBottom:6 }}>◆ Korvus</div>
          <div style={{ fontSize:28, fontWeight:900, color:"#fff", marginBottom:20 }}>Admin Dashboard</div>
          <div style={{ display:"flex", gap:10, maxWidth:440 }}>
            <input type="password" value={key} onChange={e=>setKey(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load()}
              placeholder="Admin key" style={{ flex:1, padding:"10px 14px", background:"#111", border:"1px solid rgba(201,168,76,0.25)", borderRadius:10, color:"#fff", fontSize:14, outline:"none" }}/>
            <button onClick={load} disabled={loading||!key}
              style={{ padding:"10px 22px", background:"linear-gradient(135deg,#e8c875,#ffe87a)", color:"#000", border:"none", borderRadius:10, fontSize:14, fontWeight:800, cursor:"pointer", opacity:key?1:0.4 }}>
              {loading ? "Loading…" : "Load"}
            </button>
          </div>
          {err && <div style={{ color:"#FF3B30", fontSize:13, marginTop:8 }}>{err}</div>}
        </div>

        {data && (<>
          {/* Stats row */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:28 }}>
            {[
              { label:"Total Signups",   val: data.subscribers.total,  color:"#e8c875" },
              { label:"Pro Waitlist",    val: data.subscribers.pro,    color:"#00C805" },
              { label:"Free Waitlist",   val: data.subscribers.free,   color:"#60A5FA" },
              { label:"Registered Users",val: data.users.total,        color:"#FF6B35" },
            ].map(s=>(
              <div key={s.label} style={{ background:"#0F0F0F", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:"18px 16px" }}>
                <div style={{ fontSize:30, fontWeight:900, color:s.color, lineHeight:1, marginBottom:4 }}>{s.val}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.45)", textTransform:"uppercase", letterSpacing:".1em" }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Subscribers table */}
          <div style={{ background:"#0F0F0F", border:"1px solid rgba(255,255,255,0.08)", borderRadius:16, marginBottom:24, overflow:"hidden" }}>
            <div style={{ padding:"16px 20px", borderBottom:"1px solid rgba(255,255,255,0.07)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ fontSize:14, fontWeight:700 }}>Recent Waitlist Signups</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)" }}>Most recent 20</div>
            </div>
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr style={{ background:"rgba(255,255,255,0.03)" }}>
                    {["Email","Plan","Date"].map(h=>(
                      <th key={h} style={{ padding:"10px 20px", textAlign:"left", fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:".1em", color:"rgba(255,255,255,0.4)", whiteSpace:"nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.subscribers.recent.map((s,i)=>(
                    <tr key={i} style={{ borderTop:"1px solid rgba(255,255,255,0.05)" }}>
                      <td style={{ padding:"10px 20px", fontSize:13, color:"#fff" }}>{s.email}</td>
                      <td style={{ padding:"10px 20px" }}>
                        <span style={{ fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:20, background: s.plan==="pro"?"rgba(201,168,76,0.12)":"rgba(255,255,255,0.06)", color: s.plan==="pro"?"#e8c875":"rgba(255,255,255,0.5)" }}>{s.plan||"free"}</span>
                      </td>
                      <td style={{ padding:"10px 20px", fontSize:12, color:"rgba(255,255,255,0.45)" }}>{s.date ? new Date(s.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "—"}</td>
                    </tr>
                  ))}
                  {data.subscribers.recent.length === 0 && (
                    <tr><td colSpan={3} style={{ padding:"24px 20px", textAlign:"center", color:"rgba(255,255,255,0.3)", fontSize:13 }}>No signups yet</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Users leaderboard */}
          {data.users.leaderboard.length > 0 && (
            <div style={{ background:"#0F0F0F", border:"1px solid rgba(255,255,255,0.08)", borderRadius:16, overflow:"hidden" }}>
              <div style={{ padding:"16px 20px", borderBottom:"1px solid rgba(255,255,255,0.07)" }}>
                <div style={{ fontSize:14, fontWeight:700 }}>User Leaderboard (by points)</div>
              </div>
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ background:"rgba(255,255,255,0.03)" }}>
                      {["#","Email","Points","Game","Analysis","Streak","Joined"].map(h=>(
                        <th key={h} style={{ padding:"10px 16px", textAlign:"left", fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:".1em", color:"rgba(255,255,255,0.4)", whiteSpace:"nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.users.leaderboard.map((u,i)=>(
                      <tr key={i} style={{ borderTop:"1px solid rgba(255,255,255,0.05)" }}>
                        <td style={{ padding:"10px 16px", fontSize:13, fontWeight:800, color: RANK_COLORS[Math.min(i,4)] }}>#{i+1}</td>
                        <td style={{ padding:"10px 16px", fontSize:13, color:"#fff" }}>{u.email}</td>
                        <td style={{ padding:"10px 16px", fontSize:14, fontWeight:800, color:"#e8c875" }}>{u.points||0}</td>
                        <td style={{ padding:"10px 16px", fontSize:12, color:"rgba(255,255,255,0.82)" }}>{u.gamePoints||0}</td>
                        <td style={{ padding:"10px 16px", fontSize:12, color:"rgba(255,255,255,0.82)" }}>{u.analysisPoints||0}</td>
                        <td style={{ padding:"10px 16px", fontSize:12, color:"rgba(255,255,255,0.82)", display:"flex", alignItems:"center", gap:4 }}><Flame size={12} strokeWidth={2} color="#FF6B35"/>{u.loginStreak||1}d</td>
                        <td style={{ padding:"10px 16px", fontSize:11, color:"rgba(255,255,255,0.35)" }}>{u.joinedAt ? new Date(u.joinedAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Danger zone */}
          <div style={{ background:"#0F0F0F", border:"1px solid rgba(255,59,48,0.25)", borderRadius:16, padding:"20px 22px", marginTop:24 }}>
            <div style={{ fontSize:13, fontWeight:700, color:"rgba(255,59,48,0.85)", marginBottom:6 }}>Danger Zone</div>
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", marginBottom:14 }}>Permanently delete all performance tracking data (hma_track_calls). Cannot be undone.</div>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <button onClick={clearTrackRecord} disabled={!key}
                style={{ padding:"9px 20px", background:"rgba(255,59,48,0.12)", border:"1px solid rgba(255,59,48,0.35)", borderRadius:9, color:"#FF3B30", fontSize:13, fontWeight:700, cursor:"pointer", opacity:key?1:0.4 }}>
                Clear Track Record
              </button>
              {clearStatus && <span style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>{clearStatus}</span>}
            </div>
          </div>

          <div style={{ fontSize:11, color:"rgba(255,255,255,0.25)", marginTop:16, textAlign:"right" }}>Generated {new Date(data.generatedAt).toLocaleString()}</div>
        </>)}
      </div>
    </div>
  );
}
